import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { Subject } from 'rxjs';
import { TablepageBaseComponent } from '../../abstract/tablepage-base/tablepage-base.component';
import { AlertDialogComponent } from '../../dialogs/alert-dialog/alert-dialog.component';
import { Alert } from '../../models/summary';
import { ApiService } from '../../services/api.service';
import { UiNotificationService } from '../../services/ui-notification.service';
import { StatusDatePipe } from '../../utilities/date-pipes';
import { Parameters } from '../../utilities/parameters';
import { Reset } from '../../utilities/reset';

@Component({
  selector: 'app-alerts',
  imports: [
    FormsModule,
    CommonModule,
    TablepageBaseComponent,
    TableModule,
    TranslatePipe,
    InputTextModule,
    StatusDatePipe,
    ButtonModule,
    AlertDialogComponent
  ],
  templateUrl: './alerts.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class AlertsComponent implements OnInit, OnDestroy {
  private apiService = inject(ApiService);
  messageService = inject(UiNotificationService);
  private translate = inject(TranslateService);

  loading: boolean = false;
  dtTrigger: Subject<boolean> = new Subject<boolean>();

  alerts: Alert[] = [];

  selectedAlert: Alert = Reset.alert();
  showDialog: boolean = false;

  newAlerts: number = 0;

  ngOnInit(): void {
      this.loadData();
  }

  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
  }

  getAlertValue(alert : Alert) : string {
    const percent : number[] = [3, 4, 7, 8, 11, 12, 15, 16];
    const heart: number[] = [1, 2, 5, 6]
    const breath: number[] = [9, 10, 13, 14]

    const linguaBrowser: string = this.translate.currentLang() || this.translate.fallbackLang() || 'en';
    var v: string = '';
    var u: string = '';

    if (percent.includes(alert.type)) {
      v = new Intl.NumberFormat(linguaBrowser, {
        style: 'percent',
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(alert.value);
    } else if (heart.includes(alert.type)) {
      v = new Intl.NumberFormat(linguaBrowser, {
        maximumFractionDigits: 0
      }).format(alert.value);

      u = "[bpm]";
    } else if (breath.includes(alert.type)) {
      v = new Intl.NumberFormat(linguaBrowser, {
        maximumFractionDigits: 0
      }).format(alert.value);

      u = "[rpm]";
    } else {
      return new Intl.NumberFormat(linguaBrowser, {
        maximumFractionDigits: 0
      }).format(alert.value);
    }      

    return `${v} ${u}`
  }

  onAlertDialogClosed(alert: Alert) {
    this.alerts = this.alerts.map(item => {
      // Verifica se l'oggetto corrente corrisponde per id, timestamp e type
      if (
        item.userId === alert.userId &&
        item.timeStamp === alert.timeStamp &&
        item.type === alert.type
      ) {
        // Ritorna un nuovo oggetto che unisce lo stato precedente con le modifiche
        return { ...item, ...alert };
      }
      // Altrimenti ritorna l'oggetto invariato
      return item;
    });

    this.selectedAlert = Reset.alert();
  }

  onAlertEdit(alert: Alert) {
    this.selectedAlert = alert;
    this.showDialog = true;
  }

  private loadData() {
     this.loading = true;

    this.apiService.getAlerts(Parameters.loggedUser.id).subscribe({
      next: (data) => {
        this.alerts = data;
        this.newAlerts = data.filter(a => !a.isChecked).length;

        this.dtTrigger.next(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.messageService.showError(err);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }
}
